import Api from "../../api";

import { Advertisement } from "./models.jsx";

const advertisementsUrl = "requests";
const contentUrl = "content";

class AdvertisementApi extends Api {
	
	getByPlace(placeId, startItem, endItem, callback) {

	    var url = this.baseUrl + advertisementsUrl;
	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem},
	    	params: { placeId: placeId }
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new Advertisement(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	getByCategory(category, startItem, endItem, keyword, startDate, endDate, sort, state, callback) {

	    var url = this.baseUrl + advertisementsUrl;
	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem},
	    	params: { category: category, state: state, startDate: startDate, endDate: endDate, sort: sort, keyword: keyword}
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new Advertisement(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	
	create(advertisement, callback) {
		var url = this.baseUrl + advertisementsUrl;
		this.client.post(url, advertisement)
			.then((response) => {
				callback({
					result: new Advertisement(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	delete(advertisementId, callback) {
		var url = this.baseUrl + advertisementsUrl + "/" + advertisementId;
		this.client.delete(url)
			.then((response) => {
				callback({
					result: response.data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	update(advertisement, callback) {
		var url = this.baseUrl + advertisementsUrl + "/" + advertisement.id;
		this.client.put(url, advertisement)
			.then((response) => {
				callback({
					result: new Advertisement(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	getMedia(advertisementId, binId, callbacks) {
	    let url = this.getMediaUrl(advertisementId, binId);
	    this.loadBinary(url, callbacks);
	}

	getMediaUrl(advertisementId, binId) {
	    return this.baseUrl + advertisementsUrl + "/" + advertisementId + "/" + contentUrl + "/" + binId;
	}
}

class AdsServiceApi{

	constructor(baseUrl) {
		this.advertisements = new AdvertisementApi(baseUrl);
	}

}

export default AdsServiceApi;